export default "__VITE_ASSET__PddRjgkU__"